// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "js/" + chunkId + "-legacy." + {"175":"4c464b5a","321":"aef220c2","347":"55c7a023","411":"fa129446","522":"1eaf6fbc","588":"7aa7e35f","672":"cad756bf","831":"7c2471f6","994":"8cee2245"}[chunkId] + ".js";
};